<template>
  <div class="c2">
    <div class="c2-content">
      <div class="list-box">
        <!-- 动态渲染 defaultdata 中的每一项 -->
        <div
          class="list-item"
          v-for="(item, index) in defaultdata"
          :key="index"
        >
          <div class="list-top">
            <div class="list-t-img">
              <!-- 显示图标 -->
              <img
                src="@/assets/temimg13/tem13_icon_disc.png"
                alt=""
                class="disc_icon"
              />
            </div>
            <!-- 显示标题 -->
            <div class="list-t-title">{{ item.value1 }}</div>
          </div>
          <!-- 显示内容 -->
          <div class="list-cent">{{ item.value2 }}</div>
          <div class="list-bottom">
            <!-- 显示时间 -->
            <div class="list-b-time">{{ item.value3 }}</div>
            <div class="list-b-box">
              <!-- 显示来源 -->
              <div class="list-b-source">{{ item.value4 }}</div>
              |
              <!-- 显示级别 -->
              <div class="list-b-level">{{ item.value5 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as methods from "./method.js";
export default {
  name: "template.scope108",
  props: {
    vdata: {
      type: Array,
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    valuemap: {
      type: [Array, String],
      default: () => [],
    },
  },
  data() {
    return {
      isList: true,
      textnum: 127,
      timer: null,
      defaultdata: [
        {
          value1: "胡鑫宇失联仍存三大疑点",
          value2:
            "1.为什么失踪前随身带着录音笔? 2.为什么半个月前告诉妈妈“想哭”? 3.是否真的有人动过监控...",
          value3: "2022-11-24 05:10:00",
          value4: "无来源",
          value5: "正处级",
        },
        {
          value1: "胡鑫宇失联仍存三大疑点",
          value2:
            "1.为什么失踪前随身带着录音笔? 2.为什么半个月前告诉妈妈“想哭”? 3.是否真的有人动过监控...",
          value3: "2022-11-24 05:10:00",
          value4: "无来源",
          value5: "正处级",
        },
        {
          value1: "胡鑫宇失联仍存三大疑点",
          value2:
            "1.为什么失踪前随身带着录音笔? 2.为什么半个月前告诉妈妈“想哭”? 3.是否真的有人动过监控...",
          value3: "2022-11-24 05:10:00",
          value4: "无来源",
          value5: "正处级",
        },
        {
          value1: "胡鑫宇失联仍存三大疑点",
          value2:
            "1.为什么失踪前随身带着录音笔? 2.为什么半个月前告诉妈妈“想哭”? 3.是否真的有人动过监控...",
          value3: "2022-11-24 05:10:00",
          value4: "无来源",
          value5: "正处级",
        },
      ],
      valueMap: [
        { name: "标题", key: "value1" },
        { name: "文本", key: "value2" },
        { name: "时间", key: "value3" },
        { name: "备注一", key: "value4" },
        { name: "备注二", key: "value5" },
      ],
      exceldata: [],
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        this.defaultdata = n;
      }
    },
    valuemap(n) {
      if (n && n.length) {
        this.valueMap = n;
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
  },
  mounted() {
    this.$nextTick(() => {});
    if (this.valuemap && this.valuemap.length) {
      this.valueMap = this.valuemap;
    }
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
  },
  methods: {
    ...methods,
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style scoped lang="scss">
.c2 {
  width: 895px;
  height: 188px;
  margin: 0px auto 0 auto;
  position: relative;
  overflow: hidden;
  pointer-events: auto;
  cursor: pointer;
  /* 为列表项容器添加样式 */
  .list-box {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    // padding: 10px;
    box-sizing: border-box;
    overflow-y: auto; // 添加垂直滚动条
    max-height: 188px; // 设置最大高度，超出则显示滚动条
  }

  .list-item {
    width: 260px;
    height: 188px;
    background: url(@/assets/temimg13/tem_txt_bg2.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    padding: 0px 14px 0;
    overflow: hidden;
    /* 列表顶部样式 */
    .list-top {
      width: 100%;
      height: 35px;
      display: flex;
      align-items: center;
      padding: 36px 0 0;
      box-sizing: border-box;
    }
    /* 列表顶部图标样式 */
    .list-t-img {
      width: 25px;
      height: 25px;
      .disc_icon {
        width: 25px;
        height: 25px;
        transform: rotate(45deg);
      }
    }
    /* 列表顶部标题样式 */
    .list-t-title {
      width: 240px;
      height: 25px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 14px;
      color: #d5f1ff;
      line-height: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    /* 列表中部内容样式 */
    .list-cent {
      width: 250px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 12px;
      color: #bdc4d3;
      line-height: 24px;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      // white-space: nowrap;

      padding: 24px 10px 0;
    }
    /* 列表底部样式 */
    .list-bottom {
      padding: 12px 10px 0;
      width: 100%;
      height: 20px;
      /* 列表底部时间样式 */
      .list-b-time {
        width: 160px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #bdc4d3;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      /* 列表底部右侧盒子样式 */
      .list-b-box {
        padding: 6px 0 0;
        display: flex;
        width: 100px;
        justify-content: space-between;
      }
      /* 列表底部来源样式 */
      .list-b-source {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #009aff;
        line-height: 22px;
      }
      /* 列表底部级别样式 */
      .list-b-level {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #009aff;
        line-height: 22px;
      }
    }
  }
}
</style>
